import React,{useState} from 'react'
import { useLanguage } from '../Providers/LanguageContext'
import { useNavigate } from 'react-router-dom'
import Index from "../View/News/Index";
function TopbarComp(textprop) {
    const [cipbit,setCipbit]=useState(false)
    // console.log(textprop, "textprop")
    const { language, currentLanguage } = useLanguage();
    const navigate = useNavigate();
    return (
        <>
        {cipbit && <Index setCipbit={setCipbit}/>}
            <section id='mng-top'>
                <div className='container-fluid '>
                    <div className='d-flex justify-content-between flex-wrap'>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-12'>
                            <div className='left-heading'>
                                <h5>{textprop.textprop}</h5>
                            </div>
                        </div>


                        {/* view insight button */}
                        <div className='viewInsignInpBtnDiv' style={{
                            marginLeft:'auto',
                            marginTop:'10px'
                        }}>
                            <button
                            style={{
                                width:'180px'
                            }}
                                className='viewInsighBtn'
                                // onClick={() => navigate("/news", { state: { time: textprop?.time } })}
                                onClick={() => setCipbit(true)}
                            >
                                {language.view_insight}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default TopbarComp